import { useQuery } from '@tanstack/react-query';

import { getTourSalesforceInventory } from '~/services/ToursService';

export const tourSalesforceInventoryQueryKeys = {
  all: ['tour-salesforce-inventory'] as const,
  detail: (tourId: string) => [...tourSalesforceInventoryQueryKeys.all, tourId] as const,
};

/** Salesforce's live inventory for a tour, by option and departure. */
export function useGetTourSalesforceInventory(tourId: string) {
  return useQuery({
    queryKey: tourSalesforceInventoryQueryKeys.detail(tourId),
    queryFn: ({ signal }) => getTourSalesforceInventory(tourId, { signal }),
    enabled: !!tourId,
  });
}
